import { h, defineComponent, SetupContext, VNode, VNodeChildren } from 'vue';
// @ts-ignore
import { BNavbarItem } from 'buefy/dist/esm/navbar';
import { RouteName } from '@/ui/routes';

export interface NavbarItemProps {
  name: RouteName;
  id?: number;
}

export const NavbarItem = defineComponent<NavbarItemProps>({
  name: 'NavbarItem',
  props: {
    name: { type: String, required: true },
    id: { type: Number },
  },
  setup(props: NavbarItemProps, context: SetupContext) {
    return function render(): VNode {
      return h(
        BNavbarItem,
        {
          props: { tag: 'named-link' },
          attrs: { name: props.name, id: props.id },
        },
        context.slots.default?.(),
      );
    };
  },
});

export function navbarItem(content: VNodeChildren, name: RouteName) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const props: NavbarItemProps = { name };
  return h(
    BNavbarItem,
    {
      props: { tag: 'router-link' },
      attrs: { to: { name } },
    },
    content,
  );
}
